module.exports = __webpack_public_path__ + "assets/img/fr-c99a1d35.png";